<template>
  <div class="pa-4">
    <div class="text-xs-right">
      <v-btn icon @click="$emit('closeEdit')"><v-icon>close</v-icon></v-btn>
    </div>
    <v-layout>
      <v-flex class="mb-2" style="font-weight: 600; font-size: 23px">
        {{ type != 'edit' ? 'เพิ่มข้อมูลลูกค้า' : 'แก้ไขข้อมูลลูกค้า' }}
      </v-flex>
      <v-flex class="text-xs-right">
        <template v-if="$store.state.privilege.mjd_it && input.account_no && type == 'edit'">
          <v-btn color="primary" depressed @click="unlinkaccount">Unlink account</v-btn>
        </template>
      </v-flex>
    </v-layout>
    <div grid-list-md>
      <v-layout row wrap>
        <v-flex xs6 class="pr-2">
          <div class="form-control" :class="{ 'has-error': errors.has('Account No.') }">
            <div>Account No.</div>
            <input
              :disabled="type == 'edit'"
              v-validate="'required'"
              :data-vv-as="$t('Account No.')"
              name="Account No."
              v-model="input.account_no"
              type="text"
            />
            <p class="text-error" v-if="errors.has('Account No.')">
              {{ errors.first('Account No.') }}
            </p>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="form-control" :class="{ 'has-error': errors.has('RMS-Account') }">
            <div>RMS-Account</div>
            <input
              :data-vv-as="$t('RMS-Account')"
              name="RMS-Account"
              v-model="input.rms_account"
              type="text"
            />
            <p class="text-error" v-if="errors.has('RMS-Account')">
              {{ errors.first('RMS-Account') }}
            </p>
          </div>
        </v-flex>
        <v-flex xs12>
          <v-layout row wrap class="mb-0">
            <v-flex xs2 class="pr-2">
              <div>คำนำหน้าชื่อ</div>
              <div class="form-control" :class="{ 'has-error': errors.has('คำนำหน้าชื่อ') }">
                <multiselect
                  v-model="input.prefix_th"
                  :options="optionsPrefix_th"
                  :searchable="false"
                  placeholder="คำนำหน้าชื่อ"
                  name="คำนำหน้าชื่อ"
                  :allow-empty="false"
                  selectLabel
                  selectedLabel
                  deselect-label
                >
                </multiselect>
                <p class="text-error" v-if="errors.has('คำนำหน้าชื่อ')">
                  {{ errors.first('คำนำหน้าชื่อ') }}
                </p>
              </div>
            </v-flex>
            <v-flex xs5 class="pr-2">
              <div class="form-control" :class="{ 'has-error': errors.has('ชื่อ') }">
                <div>ชื่อ</div>
                <input
                  v-validate="'required'"
                  :data-vv-as="$t('ชื่อ')"
                  name="ชื่อ"
                  v-model="input.name_th"
                  type="text"
                />
                <p class="text-error" v-if="errors.has('ชื่อ')">
                  {{ errors.first('ชื่อ') }}
                </p>
              </div>
            </v-flex>
            <v-flex xs5>
              <div class="form-control" :class="{ 'has-error': errors.has('นามสกุล') }">
                <div>นามสกุล</div>
                <input
                  v-validate="'required'"
                  :data-vv-as="$t('นามสกุล')"
                  name="นามสกุล"
                  v-model="input.surname_th"
                  type="text"
                />
                <p class="text-error" v-if="errors.has('นามสกุล')">
                  {{ errors.first('นามสกุล') }}
                </p>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12>
          <v-layout row wrap class="mb-0">
            <v-flex xs2 class="pr-2">
              <div>Prefix</div>
              <div class="form-control" :class="{ 'has-error': errors.has('Prefix') }">
                <multiselect
                  v-model="input.prefix_en"
                  :options="optionsPrefix_en"
                  :searchable="false"
                  placeholder=""
                  name="Prefix"
                  :allow-empty="false"
                  selectLabel
                  selectedLabel
                  deselect-label
                >
                </multiselect>
                <p class="text-error" v-if="errors.has('Prefix')">
                  {{ errors.first('Prefix') }}
                </p>
              </div>
            </v-flex>
            <v-flex xs5 class="pr-2">
              <div class="form-control" :class="{ 'has-error': errors.has('Name') }">
                <div>Name</div>
                <input
                  v-validate="'required'"
                  :data-vv-as="$t('Name')"
                  name="Name"
                  v-model="input.name_en"
                  type="text"
                />
                <p class="text-error" v-if="errors.has('Name')">
                  {{ errors.first('Name') }}
                </p>
              </div>
            </v-flex>
            <v-flex xs5>
              <div class="form-control" :class="{ 'has-error': errors.has('Surname') }">
                <div>Surname</div>
                <input
                  v-validate="'required'"
                  :data-vv-as="$t('Surname')"
                  name="Surname"
                  v-model="input.surname_en"
                  type="text"
                />
                <p class="text-error" v-if="errors.has('Surname')">
                  {{ errors.first('Surname') }}
                </p>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs4 class="pr-2">
          <div class="form-control" :class="{ 'has-error': errors.has('เพศ') }">
            <div>เพศ</div>
            <multiselect
              v-model="input.gender"
              :options="['Male', 'Female']"
              :searchable="false"
              placeholder=""
              name="เพศ"
              :allow-empty="false"
              selectLabel
              selectedLabel
              deselect-label
            >
            </multiselect>
            <p class="text-error" v-if="errors.has('เพศ')">
              {{ errors.first('เพศ') }}
            </p>
          </div>
        </v-flex>
        <v-flex xs4>
          <div class="form-control" :class="{ 'has-error': errors.has('วันเกิด') }">
            <div>วันเกิด</div>
            <DatePickerWithoutButton v-model="input.birthday">
              <input readonly name="วันเกิด" :value="input.birthday" type="text" />
            </DatePickerWithoutButton>

            <p class="text-error" v-if="errors.has('วันเกิด')">
              {{ errors.first('วันเกิด') }}
            </p>
          </div>
        </v-flex>
        <v-flex xs6 class="pr-2">
          <div class="form-control" :class="{ 'has-error': errors.has('เบอร์โทรศัพท์') }">
            <div>เบอร์โทรศัพท์</div>
            <input
              v-validate="'required'"
              :data-vv-as="$t('เบอร์โทรศัพท์')"
              name="เบอร์โทรศัพท์"
              v-model="input.mobile_1"
              type="tel"
              @keypress="isNumber($event)"
            />
            <p class="text-error" v-if="errors.has('เบอร์โทรศัพท์')">
              {{ errors.first('เบอร์โทรศัพท์') }}
            </p>
          </div>
        </v-flex>
        <v-flex xs6 class="pr-2">
          <div class="form-control" :class="{ 'has-error': errors.has('อีเมล') }">
            <div>อีเมล</div>
            <input
              v-validate="'email'"
              :data-vv-as="$t('อีเมล')"
              name="อีเมล"
              v-model="input.email_1"
              type="text"
            />
            <p class="text-error" v-if="errors.has('อีเมล')">
              {{ errors.first('อีเมล') }}
            </p>
          </div>
        </v-flex>
        <v-flex xs6 class="pr-2">
          <div class="form-control" :class="{ 'has-error': errors.has('เบอร์โทรศัพท์2') }">
            <div>เบอร์โทรศัพท์ 2</div>
            <input
              :data-vv-as="$t('เบอร์โทรศัพท์')"
              name="เบอร์โทรศัพท์2"
              v-model="input.mobile_2"
              type="tel"
              maxlength="10"
              @keypress="isNumber($event)"
            />
            <p class="text-error" v-if="errors.has('เบอร์โทรศัพท์2')">
              {{ errors.first('เบอร์โทรศัพท์2') }}
            </p>
          </div>
        </v-flex>
        <v-flex xs6 class="pr-2">
          <div class="form-control" :class="{ 'has-error': errors.has('อีเมล2') }">
            <div>อีเมล 2</div>
            <input
              v-validate="'email'"
              :data-vv-as="$t('อีเมล')"
              name="อีเมล2"
              v-model="input.email_2"
              type="text"
            />
            <p class="text-error" v-if="errors.has('อีเมล2')">
              {{ errors.first('อีเมล2') }}
            </p>
          </div>
        </v-flex>
        <v-flex xs4 class="pr-2">
          <div class="form-control" :class="{ 'has-error': errors.has('idcard') }">
            <div>ID Card/Passport</div>
            <input
              v-validate="'required'"
              :data-vv-as="$t('ID Card/Passport')"
              name="idcard"
              v-model="input.id_card"
              type="text"
            />
            <p class="text-error" v-if="errors.has('idcard')">
              {{ errors.first('idcard') }}
            </p>
          </div>
        </v-flex>
        <v-flex xs4 class="pr-2">
          <div class="form-control" :class="{ 'has-error': errors.has('acc_status') }">
            <div>Account Status</div>
            <input
              :data-vv-as="$t('Account Status')"
              name="acc_status"
              v-model="input.account_status"
              type="text"
            />
            <p class="text-error" v-if="errors.has('acc_status')">
              {{ errors.first('acc_status') }}
            </p>
          </div>
        </v-flex>
        <v-flex xs4 class="pr-2">
          <div class="form-control" :class="{ 'has-error': errors.has('te') }">
            <div>T/E</div>
            <input
              v-validate="'required'"
              :data-vv-as="$t('T/E')"
              name="te"
              v-model="input.t_e"
              type="text"
            />
            <p class="text-error" v-if="errors.has('te')">
              {{ errors.first('te') }}
            </p>
          </div>
        </v-flex>
        <v-flex xs6>
          <div>Group</div>
          <div class="form-control" :class="{ 'has-error': errors.has('group') }">
            <input :data-vv-as="$t('Group')" name="group" type="text" v-model="input.group" />
            <p class="text-error" v-if="errors.has('group')">
              {{ errors.first('group') }}
            </p>
          </div>
        </v-flex>
        <v-flex xs6 class="pl-2">
          <div>Line id</div>
          <div class="form-control" :class="{ 'has-error': errors.has('lineid') }">
            <input :data-vv-as="$t('Line id')" name="lineid" type="text" v-model="input.lineid" />
            <p class="text-error" v-if="errors.has('lineid')">
              {{ errors.first('lineid') }}
            </p>
          </div>
        </v-flex>
      </v-layout>
    </div>
    <div class="text-xs-center mb-3">
      <v-btn @click="$emit('closeEdit')" outline color="grey">Cancel</v-btn>
      <v-btn :loading="saveloading" @click="saveData" depressed color="primary">Save</v-btn>
    </div>
    <div v-if="input.account_no && type == 'edit'">
      <PersonalProject :account_no="input.account_no"></PersonalProject>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import api from '@/api'
import DatePickerWithoutButton from '@/components/elements/DatePickerWithoutButton.vue'
import moment from 'moment'
import PersonalProject from './PersonalProject.vue'
export default {
  props: ['editdata', 'type'],
  components: {
    Multiselect,
    DatePickerWithoutButton,
    PersonalProject
  },
  data() {
    return {
      saveloading: false,
      optionsPrefix_th: ['คุณ', 'นาย', 'นาง', 'นางสาว'],
      optionsPrefix_en: ['Khun.', 'Mr.', 'Mrs.', 'Ms.', 'Miss'],
      input: {
        account_no: '',
        rms_account: '',
        prefix_th: '',
        prefix_en: '',
        name_th: '',
        surname_th: '',
        name_en: '',
        surname_en: '',
        gender: '',
        mobile_1: '',
        mobile_2: '',
        email_1: '',
        email_2: '',
        birthday: '',
        account_status: '',
        id_card: '',
        t_e: '',
        synctimestamp: '',
        group: '',
        lineid: ''
      },
      headers: [
        {
          text: 'Project name',
          value: 'name'
        },
        { text: 'Floor', value: 'floor' },
        { text: 'Unit No.', value: 'unitno' },
        { text: 'Area', value: 'area' },
        { text: 'Points', value: 'point' },
        { text: 'Group', value: 'group' },
        { text: 'Line ID', value: 'lineid' }
      ]
    }
  },

  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    if (this.type == 'edit') {
      this.input = {
        ...this.input,
        ...this.editdata,
        birthday: moment(this.editdata.birthday).format('YYYY-MM-DD')
      }
    }
  },
  methods: {
    isNumber: function (evt) {
      evt = evt ? evt : window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    async saveData() {
      var url = ''
      var data = { ...this.input, pageid: this.selectedBot.pageid }
      if (this.type == 'edit') {
        url = 'putmjdcustomerdashboard'
      } else {
        url = 'postmjdaddaccountByadmin'
      }
      if (await this.$validator.validate()) {
        this.saveloading = true
        api[url](data, (err, response) => {
          this.saveloading = false
          this.$emit('onEdit')
        })
      }
    },
    unlinkaccount() {
      var vm = this
      return new Promise((resolve, reject) => {
        api.postmjdclearaccountbyadmin(
          {
            pageid: this.selectedBot.pageid,
            account_no: this.input.account_no
          },
          (error, response) => {
            if (error) {
              reject(error)
            }
            vm.$swal.fire({
              type: 'success',
              text: 'Unlink account สำเร็จ'
            })
            resolve(response)
          }
        )
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/mjd/CustomerEdit.vue